import { createContext, useContext } from 'react';

// @TODO fixed type
export const PageContext = createContext<{ path: string }>({ path: '' });

export const usePageContext = () => useContext(PageContext);
